import { z } from 'zod';
import { BUSINESS_TYPES, LOCATION_COUNTS } from '../constants/waitlist-options.js';
import { localeSchema, rawPhoneSchema } from './common.js';
export { BUSINESS_TYPES, LOCATION_COUNTS } from '../constants/waitlist-options.js';
/**
 * Waitlist capture — features/LANDING.md.
 *
 * Seven fields, deliberately. Every extra field costs conversions and only
 * business type and location count actually qualify a lead.
 *
 * `strictObject`, not `object`. Zod strips unknown keys by default, which is the
 * `whitelist` behaviour; AGENTS.md §5 additionally requires
 * `forbidNonWhitelisted`. Silently dropping a field the caller believed was
 * meaningful hides bugs, and on a write path it hides privilege-shaped mistakes.
 */
export const createWaitlistEntrySchema = z.strictObject({
    businessName: z.string().trim().min(1).max(120),
    contactName: z.string().trim().min(1).max(120),
    /**
     * Normalise before validating, not after. `z.email()` runs its format check on
     * the value it is handed, so validating first rejects a trailing space that the
     * trim was about to remove — a real submission lost to a stray keystroke.
     * Lowercasing before storage is what makes duplicate detection work at all.
     */
    email: z.string().trim().toLowerCase().max(254).pipe(z.email()),
    phoneE164: rawPhoneSchema.optional().nullable(),
    businessType: z.enum(BUSINESS_TYPES),
    locationCount: z.enum(LOCATION_COUNTS),
    city: z.string().trim().max(80).optional().nullable(),
    locale: localeSchema.default('en'),
    utmSource: z.string().trim().max(120).optional().nullable(),
    utmMedium: z.string().trim().max(120).optional().nullable(),
    utmCampaign: z.string().trim().max(120).optional().nullable(),
    /**
     * Honeypot. Real users never see this field, so any value means a bot.
     *
     * The schema accepts anything here on purpose. features/LANDING.md requires the
     * submission be *silently* rejected, and a validation error is the opposite of
     * silent — it hands the scraper the name of the field that caught it. The
     * service inspects this, drops the write, and returns an ordinary success.
     */
    website: z.string().max(200).optional(),
});
/**
 * True when a submission should be dropped without telling the sender.
 * Kept beside the schema so the honeypot cannot be forgotten by a caller.
 */
export function isHoneypotTripped(input) {
    return typeof input.website === 'string' && input.website.length > 0;
}
//# sourceMappingURL=waitlist.js.map